var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-chips" },
    _vm._l(_vm.tables, function (table) {
      return _c(
        "button",
        {
          key: table.id,
          class: [_vm.statusClass(table), { active: _vm.isActive(table.id) }],
          attrs: { type: "button", disabled: table.isAvailable === false },
          on: {
            click: function ($event) {
              return _vm.$emit("select", table.id)
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(table.code))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }